import { DriverRegistrationPortalService } from '@gen/partnerDriverWeb/driverRegistrationPortal';
import { HttpClientBoltServer } from '@bolteu/http-client-bolt-server';
import { getAppBrand, getServerHost } from '../common/environment';
import { PORTAL_VERSION } from '../env';
import { store } from '../redux/store';
import { getLanguage } from '../redux/localization/localizationSelectors';
import { DeviceData } from '../common/deviceData';
import { PartnerDriverAuthStrategy } from './auth_strategies/PartnerDriverAuthStrategy';

const partnerDriverWebHttpClient =
  new HttpClientBoltServer<DriverRegistrationPortalService.HttpClientConstraints>(
    {
      baseUrl: getServerHost(),
    }
  );

partnerDriverWebHttpClient.init({
  standardRequestStrategy: {
    getStandardRequest: () => {
      return {
        version: PORTAL_VERSION,
        brand: getAppBrand(),
        device_os_version: DeviceData.getDeviceOsVersion(),
        device_name: DeviceData.getDeviceName(),
        deviceId: DeviceData.getDeviceId(),
        language: getLanguage(store.getState()),
      };
    },
  },
  authStrategy: {
    jwt: PartnerDriverAuthStrategy,
  },
});

const partnerDriverApiClient = new DriverRegistrationPortalService.ApiClient({
  httpClient: partnerDriverWebHttpClient,
});

export default partnerDriverApiClient;
